import * as S from '../../Booking.style';
export const MustHaveBelongings = () => {
  return (
    <div>
      <S.SectionTitle>대여 필수 소지품</S.SectionTitle>
      <S.ExtraNoticeBox backgroundColor="white" border="solid 1px #5195E6">
        여권 / 운전자 본인 명의 신용카드 / 국내 운전 면허증 / 국제 운전 면허증
      </S.ExtraNoticeBox>
      <S.ExtraNoticeBox indent={true}>
        <div>・ 실물 지참이 필수이며, 모바일 화면 또는 사본은 인정되지 않습니다.</div>
        <div>
          ・ 국내 운전면허증 뒷면에 기재된 영문 면허 정보는 국제 면허증으로 인정되지 않습니다.
        </div>
        <div>・ 체크카드 및 트래블 월렛은 사용이 불가합니다.</div>
      </S.ExtraNoticeBox>
    </div>
  );
};
